import React from "react";
import { loanCalculatorData } from "./sbiHomeLoanEmiContent";
import "./SBIHomeLoanEmiCalculator.css";
import {
  Typography,
  Tooltip,
  tooltipClasses,
  styled,
  ClickAwayListener,
  useMediaQuery,
} from "@mui/material";
import { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import Collaborators from "./Collaborators/Collaborators";
import StepOne from "./Steps/StepOne/StepOne";
import StepTwo from "./Steps/StepTwo/StepTwo";
import Calculator from "./Calculator/Calculator";
import StepThree from "./Steps/StepThree/StepThree";
import StepFour from "./Steps/StepFour";
import StepFive from "./Steps/StepFive";
import FAQ from "./FAQ/FAQ";
import StepSix from "./Steps/StepSix";
import StepSeven from "./Steps/StepSeven";
import MoreLikeThis from "./MoreLikeThis/MoreLikeThis";
import SideBar from "../../../AllSideBarForEmiCalculator/SideBar";


const SBIHomeLoanEmiCalculator = () => {
  const isSmallScreen = useMediaQuery("(max-width:576px)");
  const [openDiscloser, setOpenDiscloser] = useState(false);

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }));

  const handeDiscloserTooltipClose = () => {
    setOpenDiscloser(false);
  };

  const handeDiscloserTooltipOpen = () => {
    setOpenDiscloser(true);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


    
  const advertiserData = (
    <div>
      <Typography>
        Minemi partners with trusted lenders, and we may receive compensation
        when you click on links or take action on their site. However, this does
        not affect our evaluations or ratings. Our opinions are our own.
      </Typography>
    </div>
  );
  return (
    <>
      <div id="loan_calculator_container_shlec">
        <section className="loan_calculator_page gap-5">
          <section
            id="loan_calculator_section"
            className="w-100
          "
          >
            <section>
              <p className="pages_links bg-transparent links ">
                <Link
                  to="/"
                  underline="hover"
                  className="bg-transparent archivo"
                  style={{
                    fontSize: isSmallScreen ? 13 : 16,
                    color: "#59266d",
                    cursor: "pointer",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  Home
                </Link>
                &nbsp;
                <span
                  className="d-none d-md-inline bg-transparent ps-1 px-1 "
                  style={{
                    color: "#59266D",
                    fontFamily: "'Archivo', sans-serif",
                    fontWeight: 700,
                  }}
                >
                  &gt;
                </span>
                &nbsp;
                <Link
                  to="/calculators"
                  underline="hover"
                  className="d-none d-md-inline bg-transparent archivo"
                  style={{
                    fontSize: isSmallScreen ? 13 : 16,
                    color: "#59266d",
                    cursor: "pointer",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  Calculators
                </Link>
                &nbsp;
                <span
                  className="d-none d-md-inline bg-transparent ps-1 px-1 "
                  style={{
                    color: "#59266D",
                    fontFamily: "'Archivo', sans-serif",
                    fontWeight: 700,
                  }}
                >
                  &gt;
                </span>
                &nbsp;
                <Link
                  to="/calculators/emi-calculators"
                  underline="hover"
                  className="d-none d-md-inline bg-transparent archivo"
                  style={{
                    fontSize: isSmallScreen ? 13 : 16,
                    color: "#59266d",
                    cursor: "pointer",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  EMI Calculators
                </Link>
                &nbsp;
                <span
                  className="d-none d-md-inline bg-transparent ps-1 px-1 "
                  style={{
                    color: "#59266D",
                    fontFamily: "'Archivo', sans-serif",
                    fontWeight: 700,
                  }}
                >
                  &gt;
                </span>
                &nbsp;
                <Link
                  underline="hover"
                  className="d-none d-md-inline fw-bold bg-transparent archivo"
                  style={{
                    fontSize: isSmallScreen ? 13 : 16,
                    color: "#59266d",
                    cursor: "pointer",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  SBI Home Loan EMI Calculator{" "}
                </Link>{" "}
              </p>
              {/* loan calculation hero section data */}

              {loanCalculatorData &&
                loanCalculatorData.map((item, index) => (
                  <div
                    key={index}
                    className="contents bg-transparent mt-3 my-lg-4"
                  >
                    <div className=" mt-4 mt-lg-5 ">
                      <div id="advertiser__discloser">
                        <ClickAwayListener
                          onClickAway={handeDiscloserTooltipClose}
                        >
                          <div className="w-auto">
                            <LightTooltip
                              arrow
                              open={openDiscloser}
                              title={<div>{advertiserData}</div>}
                            >
                              <div>
                                <Link
                                  underline="hover"
                                  style={{
                                    fontSize: 13,
                                    lineHeight: "20px",
                                    fontFamily: "'Archivo', sans-serif",
                                  }}
                                  onClick={handeDiscloserTooltipOpen}
                                >
                                  Advertiser disclosure
                                </Link>
                              </div>
                            </LightTooltip>
                          </div>
                        </ClickAwayListener>
                      </div>

                      <div className="content_heading d-flex flex-column align-items-start mt-2">
                        <Typography
                          className="bg-transparent archivo fw-bold"
                          sx={{
                            fontSize: {
                              xs: "32px",
                              sm: "35.4312px",
                              md: "40.2752px",
                              lg: "53.1927px",
                            },
                            lineHeight: {
                              xs: "38px",
                              sm: "42.0745px",
                              md: "47.8268px",
                              lg: "63.1663px",
                            },
                            letterSpacing: "0.04px",
                            textAlign: "start",
                            fontFamily: "'Archivo', sans-serif",
                          }}
                        >
                          {item.heading}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 16,
                            lineHeight: "24px",
                            letterSpacing: "0.08px",
                            fontFamily: "'Archivo',sans-serif",
                          }}
                          className="sub-heading bg-transparent my-2 archivo"
                        >
                          {item.subHeading}
                        </Typography>
                      </div>
                    </div>
                  </div>
                ))}
            </section>
            <section className="calculator_section">
              <div>
                <Typography
                  sx={{
                    fontSize: "24px",
                    lineHeight: "24px",
                    textAlign: "start",
                    fontFamily: "'Archivo', sans-serif",
                    color: "#1F1F1F",
                    fontWeight: 700,
                  }}
                >
                  Calculate Your SBI Home Loan EMI
                </Typography>
                <Typography
                  sx={{
                    fontSize: "16px",
                    lineHeight: "20px",
                    textAlign: "start",
                    fontFamily: "'Archivo', sans-serif",
                    color: "#1F1F1F",
                    fontWeight: 500,
                  }}
                  className="my-3"
                >
                  Simply enter the loan amount, interest rate, and tenure to
                  calculate your estimated EMI. The SBI EMI Calculator helps you
                  visualize your monthly payments and total repayment amount for
                  greater clarity and budgeting.
                </Typography>
              </div>
              <Calculator />
            </section>
          </section>
          <div className="d-flex flex-column flex-md-row align-items-start mt-4 gap-4 gap-md-5 w-100">
            <section id="loan_calculator_content_data_shlec">
              <section className="">
                {/* loan refinance hero section data */}

                {loanCalculatorData &&
                  loanCalculatorData.map((item, index) => (
                    <div key={index} className="contents bg-transparent">
                      <div className="">
                        <div className="notice rounded">
                          <Typography
                            sx={{
                              fontSize: "11.008px",
                              lineHeight: "16.512px",
                              letterSpacing: "0.64px",
                              textAlign: "start",
                              // color: "#ffffff",
                              // color: "#000",
                              color: "#8A8A8A",
                              fontFamily: "'Archivo', sans-serif",
                            }}
                            className="notic_text bg-transparent archivo  p-2 "
                          >
                            {item.notice}
                          </Typography>
                        </div>
                      </div>
                      <div id="updation_content" className="mt-4">
                        <div className="d-flex">
                          <p className="updation_heading archivo">
                            {item.updationText}{" "}
                            <span className="archivo">
                              &nbsp;{item.updateTime}
                            </span>
                          </p>
                        </div>
                        <div>
                          <Collaborators />
                        </div>
                      </div>
                    </div>
                  ))}
              </section>
              <section id="step_one">
                <StepOne />
              </section>
              <section id="step_two" className="mt-2 ">
                <StepTwo />
              </section>
              <section id="step_two" className="mt-5 ">
                <StepThree />
              </section>
              <section id="step_two" className="mt-3 ">
                <StepFour />
              </section>
              <section id="step_two" className="mt-3 ">
                <StepFive />
              </section>
              <section id="step_two" className="mt-4 ">
                <StepSix />
              </section>
              <section id="step_two" className="mt-5 ">
                <StepSeven />
              </section>
              <section className="mt-3">
                <FAQ />
              </section>
            </section>
            <aside id="side_bar__container_emi_links_shlec" className="">
              <div className={` `}>
                <SideBar bank={"sbihl"} />{" "}
              </div>
            </aside>
          </div>
        </section>
        <section className="w-100">
          <MoreLikeThis />
        </section>
      </div>
    </>
  );
};

export default SBIHomeLoanEmiCalculator;
